import React, { useEffect } from 'react';
import OpenApp from "../components/OpenApp/Download";
import h5Share from '@/utils/h5Share'
// import vConsole from "../utils/vConsole";
import Vconsole from 'vconsole'

 const weixinBox = () => {
  useEffect(()=> {
    const vConsole = new Vconsole()
    console.log(vConsole);
    h5Share.main({
      title: `我正在参与在新年许愿，帮我助力下获得财神灵签`,
      desc: '愿望会带到天下第一财神庙进行代许',
      link: window.location.href,
      imgUrl:  'https://file.wogoo.com/app/logo/logo7.png',
      wxShare:{
        shareData:{
          imgUrl: 'https://file.wogoo.com/app/logo/logo7.png'
        }
      }
    })
  },[])
  return (
    <OpenApp></OpenApp>
  )
}


export default weixinBox





// WEBPACK FOOTER //
// ./src/views/weixin.js